import { curry, get } from 'lodash';
import { OrNull } from '~shared/types';

export const by = curry(
  (propertyKey: string, id: string, item: any) =>
    propertyKey && get(item, propertyKey) === id,
);
export const outBy = curry((propertyKey: string, id: string, item: any) => {
  const property = get(item, propertyKey);
  return property !== id;
});

export const outById = curry((id: OrNull<string>, item: any) => {
  const property = get(item, 'id');
  return property !== id;
});
export const byId = curry((id: OrNull<string>, item: any) => {
  const property = get(item, 'id');
  return property === id;
});
export const byPath = curry((path: string, item: any) => {
  const property = get(item, 'path');
  return property === path;
});

export function exists(propertyKey: string = 'id', id: string, items: any[]) {
  return items.findIndex(by(propertyKey, id)) !== -1;
}
